import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeApplicationResponse } from 'src/types/shared/Challenge';

export const editApplicationSummaryRequest = createAction('editApplicationSummaryRequest');
export const editApplicationSummarySuccess = createAction('editApplicationSummarySuccess');
export const editApplicationSummaryFailure = createAction('editApplicationSummaryFailure');

export const editApplicationSummary = (
    id: number,
    postbody: EditApplicationSummaryRequest,
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(editApplicationSummaryRequest());
    try {
        await api.post<EditApplicationSummaryRequest, ChallengeApplicationResponse>(
            `admin/challengeApplications/${id}`,
            postbody,
        );

        dispatch(editApplicationSummarySuccess());
    } catch (e: any) {
        handleApiErrors(dispatch, editApplicationSummaryFailure, e);
    }
};

export interface EditApplicationSummaryRequest {
    summary: string;
}
